import React, { useState } from "react";
import violaCity from "../images/viola-city.png";
import violaNature from "../images/viola-nature.png";
import Title from "./Title";
import { useTranslation } from "react-i18next";

export default function About() {
  const { t } = useTranslation();
  const [activeSide, setActiveSide] = useState(null);

  const eventHandlers = (side) => ({
    onMouseEnter: () => setActiveSide(side),
    onMouseLeave: () => setActiveSide(null),
    onClick: () => setActiveSide(side),
  });

  return (
    <section id={t("link-about")} className="about-section section">
      <Title title={t("about-title")} />
      <div className="about-info">
        <div
          className={`double-img ${activeSide ? `active-${activeSide}` : ""}`}
        >
          <div className="img-vio-left" {...eventHandlers("left")}>
            <img src={violaCity} className="vio-img-1" alt="viola" />
          </div>

          <div className="img-vio" {...eventHandlers("right")}>
            <img src={violaNature} className="vio-img-2" alt="viola" />
          </div>
        </div>
        <div className="text">
          <p>{t("about-text")}</p>
        </div>
      </div>
    </section>
  );
}
